<div class='modal-header modal-header--full' (click)="$event.stopPropagation()">
  <h4 class='modal-title'>
    {{ 'TITLE.AUDIT_DIALOG' | translate }}: {{ auditDialog.applicationName }}
  </h4>
</div>

<div class='modal-body bg-white modal-body--full' (click)="$event.stopPropagation()">
  <div class="audit-body" *ngIf="!loading">
    <div class="d-flex justify-content-between flex-row align-items-end">
      <div class="audit-note">
        <label class="d-flex align-items-center">
          {{ 'LABELS.NOTES' | translate }}
          <pt-icon
            [size]="14"
            class="cursor-pointer ms-1 d-flex"
            [ngbTooltip]='"LABELS.EDIT" | translate' container='body'
            (click)="openNote()"
            [key]='IconEdit'>
          </pt-icon>
        </label>
        <p class="notes text-ellipsis">{{ appAuditCve?.note }}</p>
      </div>

      <button type='button' class='btn btn-outline-primary btn-sm ms-2'
              [disabled]="loading"
              (click)='reload();'>
        <pt-icon [key]='IconReload'
        ></pt-icon>
      </button>
    </div>
    <!--    [detailRowAutoHeight]="true"-->
    <div class="audit-table">
      <ag-grid-angular
        *ngIf="gridOption"
        class='ag-theme-balham w-100 h-100'
        [gridOptions]='gridOption'
        [enableCellChangeFlash]="true"
        [singleClickEdit]="true"
        [masterDetail]="true"

        [detailRowHeight]="350"
        [detailCellRenderer]="detailCellRenderer"
        [stopEditingWhenCellsLoseFocus]="true"
        (rowClicked)="expandRow($event)"
        (gridReady)="onGridReady($event)"
      ></ag-grid-angular>
    </div>
  </div>

  <ng-template #vulnerabilityCol let-node>
    <div class="d-flex align-items-center gap-1">
      <div class="d-flex align-items-center justify-content-center"
           ngbTooltip="Vulnerabilità dipendente da configurazioni" container="body"
           [style.height.px]="18" [style.width.px]="22" *ngIf="node.row?.missingMatch">
        <pt-icon class='text-warning d-flex' [key]='IconWarning'></pt-icon>
      </div>
      <div class="d-flex align-items-center justify-content-center"
           ngbTooltip="RID Modificato" container="body"
           [style.height.px]="18" [style.width.px]="22" *ngIf="node.row?.ridOverwritten">
        <pt-icon iconType="SVG" [size]="16" key="write-outline.svg" imageClass="opacity-50"></pt-icon>
      </div>
      <div class="d-flex align-items-center justify-content-center"
           ngbTooltip="vulnerabilità soppressa" container="body"
           [style.height.px]="18" [style.width.px]="22" *ngIf="node.row?.suppressed">
        <pt-icon iconType="SVG" [size]="16" key="block.svg" imageClass="opacity-50"></pt-icon>
      </div>
      <span class="text-link" (click)="openUrl(node.row.url)">{{ node.row?.name }}</span>
    </div>
  </ng-template>

  <div class="audit-body-loading" *ngIf="loading">
    <div>
      {{ 'MESSAGE.LOADING' | translate }}

      <div class="spinner-border spinner-border-sm me-2 text-muted" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>

    </div>
  </div>
</div>

<div class='modal-footer bg-white modal-footer--full' (click)="$event.stopPropagation()">

  <!--  <button type='button' class='btn btn-danger btn-sm me-auto'-->
  <!--          (click)='removeSecurityToolType()'>-->
  <!--    {{ 'BUTTON.DELETE' | translate }}-->
  <!--  </button>-->

  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm m-0'
          (click)='close()'>
    {{ 'BUTTON.CLOSE' | translate }}
  </button>
</div>
